import type { BaseRouteType, BaseMethodType } from '../types.ts'
import { z } from "zod";
export const tagsGetAdminFrequently_asked_questionsCount = z.any()
export type TagsGetAdminFrequently_asked_questionsCount = z.infer<typeof tagsGetAdminFrequently_asked_questionsCount>

export const querystringGetAdminFrequently_asked_questionsCount = z.object({ "page": z.string().optional(), "perPage": z.string().optional(), "text": z.string().optional(), "filter": z.union([z.literal("ALL"), z.literal("PUBLIC"), z.literal("HIDDEN")]).optional(), "order": z.union([z.literal("asc"), z.literal("desc")]).optional() })
export type QuerystringGetAdminFrequently_asked_questionsCount = z.infer<typeof querystringGetAdminFrequently_asked_questionsCount>

export const responseGetAdminFrequently_asked_questionsCount = z.object({ "payload": z.object({ "count": z.number() }).optional(), "errors": z.any(), "message": z.string().optional() })
export type ResponseGetAdminFrequently_asked_questionsCount = z.infer<typeof responseGetAdminFrequently_asked_questionsCount>

interface IGetAdminFrequently_asked_questionsCount extends BaseMethodType {
  tags: TagsGetAdminFrequently_asked_questionsCount,
  querystring: QuerystringGetAdminFrequently_asked_questionsCount,
  response: ResponseGetAdminFrequently_asked_questionsCount
}
export const URL = '/admin/frequently-asked-questions/count'
export const validation = {
  get: {
    tags: tagsGetAdminFrequently_asked_questionsCount,
    querystring: querystringGetAdminFrequently_asked_questionsCount,
    response: responseGetAdminFrequently_asked_questionsCount
  }
}
export interface AdminFrequently_asked_questionsCount extends BaseRouteType {
  get: IGetAdminFrequently_asked_questionsCount
}